import React, { useState, useEffect } from "react";
import Butterfly from "../../assets/Butterfly.svg";
import ThoughtBoxTopics from "../../assets/ThoughtBoxTopics.png";
import "./HeroContent.css";

const topics = [
  "Artificial Intelligence",
  "Cloud Computing",
  "Theatre",
  "Astrology",
  "Knowledge graph",
  "Architecture",
  "Gen AI",
  "Screen Writing",
];

function HeroContent() {
  /*  const [currentTopic, setCurrentTopic] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTopic((prevTopic) => (prevTopic + 1) % topics.length);
    }, 5000); // Topic changes every 3 seconds (same as animation duration)

    return () => clearInterval(interval); // Clean up the interval when the component unmounts
  }, []); */

  return (
    <section class="hero" id="home">
      <div class="hero-content">
        <img class="butterfly-h" src={Butterfly} />
        <div className="quote-container">
          {/* <img class="butterfly-h" src={Butterfly} /> */}
          <h2 class="hero-quote">
            "People who love all fields of knowledge are the ones who can best
            spot the patterns that exist across nature."
          </h2>
        </div>
        <p class="author">- Walter Isaacson</p>
        <a href="/about" class="btn">
          What Thought Box's About?
        </a>
      </div>
      <div class="thought-box-hero-logo">
        <img class="logo-shadow" src={ThoughtBoxTopics} />
        {/* <div className="topic-title">
          {" "}
          {
            topics[currentTopic]
          } {/* Dynamically render the current topic */}{" "}
        {/* </div> */}
      </div>
    </section>
  );
}

export default HeroContent;
